export default __webpack_public_path__ + "static/media/camp.0535a2d0.png";